module.exports = __webpack_public_path__ + "img/GoldFbReview.703a430c.png";